import { render } from "./BasePaginationDefault.vue?vue&type=template&id=2e49f238"
import script from "./BasePaginationDefault.vue?vue&type=script&lang=js"
export * from "./BasePaginationDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__